import * as React from "react";
import Icon from "app/components/shared/Icon";
import Badge from "app/components/shared/Badge";
import Colors from "app/constants/analytics/Colors";

type Props = {
  state: string;
};

const ResultBadge: React.ComponentType<Props> = (props: Props) => {
  const statusStyle = (state: string) => {
    switch (state) {
      case "pending":
      case "running":
      case "finished":
        return {
          backgroundColor: Colors.BASE_GRAY,
          color: Colors.WHITE,
          border: "1px solid transparent",
          padding: "4px 13px 4px 14px",
        };
      default:
        return {};
    }
  };

  const badgeStyle = {
    fontFamily:
      "SF Pro Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, sans-serif",
    fontStyle: "normal",
    fontSize: "11px",
    lineHeight: "13px",
    letterSpacing: "0.1em",
    textAlign: "center",
    textTransform: "uppercase",
    position: "relative",
  } as const;

  return (
    <div>
      <Badge
        // @ts-expect-error - TS2769 - No overload matches this call.
        role="status"
        className="font-semibold"
        style={{ ...badgeStyle, ...statusStyle(props.state) }}
      >
        {props.state}
      </Badge>
    </div>
  );
};

export default ResultBadge;
